(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('iso-country-codes', {
            parent: 'entity',
            url: '/iso-country-codes',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.iso_country_codes.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes.html',
                    controller: 'Iso_country_codesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('iso_country_codes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('iso-country-codes-detail', {
            parent: 'iso-country-codes',
            url: '/iso-country-codes/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'uniromaLandingApp.iso_country_codes.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-detail.html',
                    controller: 'Iso_country_codesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('iso_country_codes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Iso_country_codes', function($stateParams, Iso_country_codes) {
                    return Iso_country_codes.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'iso-country-codes',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('iso-country-codes-detail.edit', {
            parent: 'iso-country-codes-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-dialog.html',
                    controller: 'Iso_country_codesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Iso_country_codes', function(Iso_country_codes) {
                            return Iso_country_codes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('iso-country-codes.new', {
            parent: 'iso-country-codes',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-dialog.html',
                    controller: 'Iso_country_codesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('iso-country-codes', null, { reload: 'iso-country-codes' });
                }, function() {
                    $state.go('iso-country-codes');
                });
            }]
        })
        .state('iso-country-codes.edit', {
            parent: 'iso-country-codes',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-dialog.html',
                    controller: 'Iso_country_codesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Iso_country_codes', function(Iso_country_codes) {
                            return Iso_country_codes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('iso-country-codes', null, { reload: 'iso-country-codes' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('iso-country-codes.delete', {
            parent: 'iso-country-codes',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/iso-country-codes/iso-country-codes-delete-dialog.html',
                    controller: 'Iso_country_codesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Iso_country_codes', function(Iso_country_codes) {
                            return Iso_country_codes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('iso-country-codes', null, { reload: 'iso-country-codes' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
